<div class="admin-users-container">
  <app-datatable
    data-testid="admin-users-datatable"
    [rowData]="dataSource().data"
    [columns]="datatableColumns"
    [configurationInput]="datatableConfig"
    [customColumnDef]="[
      { name: 'iconId', isSortable: false, template: iconColumn },
      { name: 'name', isSortable: true, template: nameColumn },
      { name: 'userId', isSortable: true, template: userIdColumn },
      { name: 'userGroupId', isSortable: true, template: userGroupColumn },
      { name: 'firebaseUid', isSortable: true, template: firebaseUidColumn },
    ]"
    [total]="store.dataTotal$()"
    [loaderConfig]="skeletonLoaderConfig"
    [isInitialDataLoaded]="loadedTableData()"
    [loadingData]="store.dataLoading$()"
    (dataRefreshRequest)="datatableParams$.next($event)"
  />

  <ng-template #iconColumn let-row="row">
    <div class="flex items-center">
      <app-icon-badge
        [content]="row.iconId"
        fallbackBackgroundColor="var(--shikenso-gray-base)"
        [fallbackText]="row.name ?? ''"
        [borderRadius]="100"
        [size]="40"
        [iconSize]="40"
        [fontSize]="16"
        alt="User"
      />
    </div>
  </ng-template>

  <ng-template #userIdColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.userId }}</span>
    </div>
  </ng-template>

  <ng-template #userGroupColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.userGroupName ?? row.userGroupId }}</span>
    </div>
  </ng-template>

  <ng-template #nameColumn let-row="row">
    <div class="flex items-center">
      <span class="font-bold">{{ row.name ?? '-' }}</span>
    </div>
  </ng-template>

  <ng-template #firebaseUidColumn let-row="row">
    <div class="flex items-center">
      <span>{{ row.firebaseUid }}</span>
    </div>
  </ng-template>
</div>
